module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "section-white content-padded"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否开启",
      "prop": "content"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.is_open),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_open", $$v)
      },
      expression: "form.is_open"
    }
  }), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只有储值面额里面配置的是 充值送积分 才翻倍，充值送钱 不翻倍")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间段",
      "prop": "content"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.form.datetimerange),
      callback: function($$v) {
        _vm.$set(_vm.form, "datetimerange", $$v)
      },
      expression: "form.datetimerange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "翻倍数",
      "prop": "content"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 1,
      "max": 10
    },
    model: {
      value: (_vm.form.multiple),
      callback: function($$v) {
        _vm.$set(_vm.form, "multiple", $$v)
      },
      expression: "form.multiple"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-40cce6a3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40cce6a3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/storeddeposit/rechargemultiple.vue
// module id = 2662
// module chunks = 0